import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum"
import { toast } from "react-toastify"
import customAPI from "../api/customAPI.js"
const { account } = stateEnum

let initialState = {
    detail: [],
    isNewEntry: false,
    partyAcId: "",
    redirectLink:""
        

}

export const setAccountDetail = createAsyncThunk("getaccountDetail",
    async ({ token, compcode, acid ,db_user}) => {
        try {

            const { data } = await customAPI.post(
                apiRoute.account.fetch,
                {
                    comp_code: compcode,
                    ac_id: acid,
                    db_user:db_user
                },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )

            return data.data
        }
        catch (error) {
            toast.error("Data not found", {
                position: "top-center"
            })
            console.log(error)
        }

    }

)

const accountSlice = createSlice({
    name: account,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },
        resetDetail: (state) => {
            state.detail = []
            state.isNewEntry = true
            state.redirectLink=""

        },
        setAcInfo: (state, action) => {
            state.partyAcId = action.payload.acId;
            //state.isUpdate = action.payload.isUpdate;
        },
        resetAcInfo: (state) => {
            state.partyAcId = {}
        },
        setRedirectLink:(state,action)=>{
            state.redirectLink=action.payload

        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(setAccountDetail.fulfilled, (state, action) => {
                state.detail = action.payload;
            })
            .addCase(setAccountDetail.rejected, (state, action) => [
                state.detail = []
            ])
    }
})
export const { resetDetail, setNewEntryMode, setAcInfo,resetAcInfo ,setRedirectLink} = accountSlice.actions
export default accountSlice.reducer